import {  useEffect, useState, useContext } from "react";
import { Navigate, useLocation, Outlet, useParams } from "react-router-dom";
import { Footer } from "../components/Footer";
import { useAuth } from "../core/AuthProvider";
import { useEvent } from "../context/eventContext";
import { get_Event_byID } from "../FirebaseUtils/dbEvent";
import { MenuHeader } from "../components/menu/PublicMenuHeader";
export const HomeLayout = () => {


    const { setSelEvent } = useEvent()
  const {  user } = useAuth()
  let location = useLocation();

    let params = new URLSearchParams(location.search);
    let from = params.get("from") 


    const { event_id } = useParams()
    useEffect(() => {
        const initData = async () => {
            console.log("INIT DATA")
            if (event_id) {
                const ev = await get_Event_byID(event_id)
                if (ev) {
                    setSelEvent(ev)
                }
            }
        }
        initData()

    }, [event_id])

  if (user && from) {
    return <Navigate to={from} />;
  }

  return (
    <div>
      <MenuHeader />
      <Outlet />
      
      <Footer />
    </div>
  )
};